import moment from "moment";

const DateTimeFormatter = (props) => {
  const runDateTimeFormartter = (dateTimeString) => {
    const formattedDateTime =
      moment(dateTimeString).format("DD-MM-YY h:mm A");
    return formattedDateTime;
  };

  return {
    format: runDateTimeFormartter,
  };
};

export default DateTimeFormatter;
